export interface GnbMenu {
  id: string;
  label: string;
  gnbKind: string;
  href?: string;
  target?: string;
  isNew?: boolean;
}

export const GNB_MAIN_MENU: GnbMenu[] = [
  {
    id: 'salaryreport',
    label: '연봉랭킹',
    href: '/salaryreport/step',
    gnbKind: 'salaryRank',
  },
  {
    id: 'jobdom',
    label: 'JOB담',
    href: '/board',
    gnbKind: 'board',
  },
  {
    id: 'dashboard',
    label: '기업현황',
    href: '/dashboard',
    gnbKind: 'companyDashboard',
  },
  {
    id: 'companylist',
    label: '기업목록',
    gnbKind: 'companyList',
  },
];

export const GNB_SESSION_MENU: GnbMenu[] = [
  {
    id: 'mypage',
    label: '마이페이지',
    href: '/mypage/career',
    gnbKind: 'profileMypage',
    isNew: true,
  },
  {
    id: 'bookmark',
    label: '스크랩',
    gnbKind: 'bookmark',
  },
  {
    id: 'logout',
    label: '로그아웃',
    gnbKind: 'profileLogout',
  },
];
